/**
 * Single source of truth for which locales the storefront's UI supports.
 *
 * `es` is the canonical locale — every UI string and DB content column has
 * a plain (unsuffixed) Spanish value. The others are "translatable" tiers:
 * each has its own i18next resource bundle (src/i18n/locales/<code>/) and,
 * for user-generated DB content, a `_${code}` column pair read by tField()
 * (src/utils/i18nContent.js).
 *
 * Import from here instead of re-declaring the list — src/hooks/useLocale.js
 * and src/components/LanguageSwitcher.js carry additional per-locale display
 * data (BCP-47 tag, flag emoji) that can't be derived from a flat list, so
 * they aren't consolidated here, but their key sets should still match this.
 */
export const CANONICAL_LOCALE = 'es';
export const TRANSLATABLE_LOCALES = ['en', 'zh', 'ja'];
export const SUPPORTED_LOCALES = [CANONICAL_LOCALE, ...TRANSLATABLE_LOCALES];
